const topicTags = [
  { label: '科幻巨制', count: '2.3万', hot: true },
  { label: '悬疑推理', count: '1.8万', hot: true },
  { label: '动作大片', count: '2.1万', hot: true },
  { label: '喜剧合集', count: '1.5万', hot: false },
  { label: '国产动画', count: '1.9万', hot: true },
  { label: '经典港片', count: '1.2万', hot: false },
  { label: '好莱坞', count: '2.5万', hot: true },
  { label: '韩影精选', count: '1.1万', hot: false },
  { label: '纪录片', count: '0.8万', hot: false },
  { label: '恐怖惊悚', count: '0.9万', hot: false },
  { label: '动画电影', count: '1.4万', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            热门标签
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            按标签发现感兴趣的电影类型与话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topicTags.map((tag) => (
            <a
              key={tag.label}
              href="#cards"
              className={`group whitespace-nowrap inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium font-label transition-all cursor-pointer ${
                tag.hot
                  ? 'bg-accent-100 text-accent-700 hover:bg-accent-500 hover:text-white'
                  : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-300 hover:text-secondary-900'
              }`}
            >
              {tag.label}
              <span className={`text-xs ${
                tag.hot ? 'text-accent-500 group-hover:text-white/80' : 'text-secondary-500 group-hover:text-secondary-700'
              }`}>
                {tag.count}
              </span>
              {tag.hot && (
                <i className="ri-fire-line text-xs text-primary-500 group-hover:text-white/80"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}